module.exports = __webpack_public_path__ + "static/media/personal.85ad311a.png";